import Vue from 'vue'
import VueRouter from 'vue-router'

const owner = () => import('@/views/owner')
const car = () => import('@/views/car')
const carinfo = () => import('@/views/carinfo')
const down = () => import('@/views/down')
const down0 = () => import('@/views/down0')
const carlogin = () => import('@/views/carlogin')
const platform = () => import('@/views/platform')
const ownerlogin = () => import('@/views/ownerlogin')
const dataLogin = () => import('@/views/dataView/login')
const dataList = () => import('@/views/dataView/list')
const unrecorded = () => import('@/views/dataView/unrecorded')
const relation = () => import('@/views/dataView/relation')
const order = () => import('@/views/order')
const orderV2 = () => import('@/views/orderV2')
const signin = () => import('@/views/signin/signin')
const share = () => import('@/views/share')
const download = () => import('@/views/download')
const register = () => import('@/views/register')
const plateNumberSearch = () => import('@/views/plateNumberSearch')
const platformSearch = () => import('@/views/platformSearch')
const activity = () => import('@/views/activity')
const orderDetail = () => import('@/views/orderDetail')
const vehicleEntry = () => import('@/views/vehicleEntry')
const orderTaking = () => import('@/views/orderTaking')
const inviteFriends = () => import('@/views/inviteFriends')
const driverOnlineStar = () => import('@/views/driverOnlineStar')
const ownerOnlineStar = () => import('@/views/ownerOnlineStar')
const driverBeanList = () => import('@/views/driverBeanList')
const openMini = () => import('@/views/openMini')
const openCarsMini = () => import('@/views/openCarsMini')
const shareLogin = () => import('@/views/sharelogin')
const searchGroup = () => import('@/views/searchGroup')
// 订单收货码
const receiptCodeLogin = () => import('@/views/receiptCode/login')
const receiptCodeSearch = () => import('@/views/receiptCode/search')
//订单数据列表
const orderDataLogin = () => import('@/views/orderData/login')
const orderDataList = () => import('@/views/orderData/orderList')
const driveCertificate = () => import("@/views/orderData/driveCertificate")
const orderDetail2 = () => import("@/views/orderData/orderDetail2")


const uploadInfo = () => import('@/views/uploadInfo')
const sfdyDriver = () => import("@/views/sfdyDriver")
const clean = () => import("@/views/orderData/clean")
const showVoucher = () => import("@/views/orderData/showVoucher")
const orderAddress = () => import("@/views/orderData/address")
const contractList = () => import("@/views/orderData/contractList")
const contractDetail = () => import("@/views/orderData/contractDetail")
const sfDetails = () => import("@/views/orderData/sfDetails")
const imgShow = () => import("@/views/orderData/imgShow")

// 下载
const downloadDriver = () => import('@/views/download/driver')
const downloadOwner = () => import('@/views/download/owner')
// 人脸认证
const rlrz = () => import('@/views/rlrz/index')
const faceResult = () => import('@/views/rlrz/faceResult')
const meidaNotify = () => import('@/views/rlrz/meidaNotify')
const getFaceUrl = () => import('@/views/rlrz/getFaceUrl')
const dzActivity = () => import('@/views/dz/activity')
const dzWjx = () => import('@/views/dz/wjx')
const faceAuth = () => import('@/views/faceAuth')
// 三方车
const yqlogin = () => import('@/views/sfc/yqlogin')
const yqdetail = () => import('@/views/sfc/yqdetail')
const yqQrcode = () => import('@/views/sfc/registercode')
const byqlogin = () => import('@/views/sfc/byqlogin')
const byqform = () => import('@/views/sfc/byqform')
const byqform1 = () => import('@/views/sfc/new/form1')
const byqform2 = () => import('@/views/sfc/new/form2')
const byqform3 = () => import('@/views/sfc/new/form3')
const upSuccess = () => import('@/views/sfc/upSuccess')
const orderCodeLogin = () => import('@/views/orderCode/login')
const orderCodeIndex = () => import('@/views/orderCode/code')

Vue.use(VueRouter)

const routes = [
    {path: '/owner', name: 'owner', component: owner},
    {path: '/car', name: 'car', component: car, meta: {title: '顺风大运'}},
    {path: '/signin', name: 'signin', component: signin, meta: {title: '在线之星'}},
    {path: '/carinfo', name: 'carinfo', component: carinfo, meta: {title: '信息认证'}},
    {path: '/down', name: 'down', component: down, meta: {title: '下载'}},
    {path: '/down0', name: 'down0', component: down0, meta: {title: '下载'}},
    {path: '/carlogin', name: 'carlogin', component: carlogin, meta: {title: '用户注册'}},
    {path: '/platform', name: 'platform', component: platform, meta: {title: '登录'}},
    {path: '/ownerlogin', name: 'ownerlogin', component: ownerlogin, meta: {title: '用户注册'}},
    {path: '/data/login', name: 'dataView', component: dataLogin, meta: {title: '登录'}},
    {path: '/data/list', name: 'dataList', component: dataList, meta: {title: '个人数据查看'}},
    {path: '/data/unrecorded', name: 'unrecorded', component: unrecorded, meta: {title: '未注册'}},
    {path: '/data/relation/:id', name: 'relation', component: relation, meta: {title: '关联手机号'}},
    {path: '/order/:id', name: 'order', component: order, meta: {title: '订单详情'}},
    {path: '/orderV2', name: 'orderV2', component: orderV2, meta: {title: '顺风大运'}},
    {path: '/sfdyDriver', name: 'sfdyDriver', component: sfdyDriver, meta: {title: '顺风大运'}},
    {path: '/share', name: 'share', component: share, meta: {title: '顺风大运'}},
    {path: '/plateNumberSearch', name: 'plateNumberSearch', component: plateNumberSearch, meta: {title: '车牌号搜索'}},
    {path: '/register/:id', name: 'register', component: register, meta: {title: '顺风大运'}},
    {path: '/platformSearch', name: 'platformSearch', component: platformSearch, meta: {title: '平台奖励查询'}},
    {path: '/download/:id', name: 'download', component: download, meta: {title: '顺风大运'}},
    // {path: '/activity', name: 'activity', component: activity, meta: {title: '大运金融'}},
    {path: '/orderDetail/:id', name: 'orderDetail', component: orderDetail, meta: {title: '顺风大运'}},
    {path: '/vehicleEntry/:id', name: 'vehicleEntry', component: vehicleEntry, meta: {title: '顺风大运'}},
    {path: '/car/:id', name: 'car', component: car, meta: {title: '顺风大运'}},
    {path: '/inviteFriends', name: 'inviteFriends', component: inviteFriends, meta: {title: '活动中心'}},//货主端
    {path: '/orderTaking', name: 'orderTaking', component: orderTaking, meta: {title: '活动中心'}},//车主端
    {path: '/driverOnlineStar', name: 'driverOnlineStar', component: driverOnlineStar, meta: {title: '在线之星'}},
    {path: '/ownerOnlineStar', name: 'ownerOnlineStar', component: ownerOnlineStar, meta: {title: '在线之星'}},
    {path: '/driverBeanList', name: 'driverBeanList', component: driverBeanList, meta: {title: '兑换记录'}},
    {path: '/openMini/:id', name: 'openMini', component: openMini, meta: {title: '顺风大运'}},
    {path: '/openCarsMini/:id', name: 'openCarsMini', component: openCarsMini, meta: {title: '顺风大运'}},
    {path: '/shareLogin/:id', name: 'shareLogin', component: shareLogin, meta: {title: '顺风大运'}},
    {path: '/uploadInfo/:id', name: 'uploadInfo', component: uploadInfo, meta: {title: '上传发货人联系方式'}},
    {path: '/searchGroup', name: 'searchGroup', component: searchGroup, meta: {title: '顺风大运'}},
    {path: '/receiptCode/login', name: '收货码登录', component: receiptCodeLogin, meta: {title: '顺风大运'}},
    {path: '/receiptCode/search', name: '收货码查询', component: receiptCodeSearch, meta: {title: '顺风大运'}},
    {path: '/', name: '订单数据登录', component: orderDataLogin, meta: {title: '顺风大运'}},
    {path: '/orderData/orderList', name: '订单数据列表', component: orderDataList, meta: {title: '顺风大运'}},
    {path: '/orderData/driveCertificate', name: '承运司机证件', component: driveCertificate, meta: {title: '承运司机证件'}},
    {path: '/orderData/orderDetail2', name: '订单详情', component: orderDetail2, meta: {title: '订单详情'}},
    {path: '/clean', name: '清缓存', component: clean, meta: {title: '清缓存'}},
    {path: '/orderData/showVoucher/:id', name: '支付凭证', component: showVoucher, meta: {title: '支付凭证'}},
    {path: '/orderData/address/:id', name: '详细起止地', component: orderAddress, meta: {title: '详细起止地'}},
    {path: '/orderData/contractList/:id', name: '合同', component: contractList, meta: {title: '合同'}},
    {path: '/orderData/contractDetail/:id/:orderNo', name: '合同详情', component: contractDetail, meta: {title: '合同详情'}},
    {path: '/orderData/sfDetails/:id', name: '身份信息', component: sfDetails, meta: {title: '身份信息'}},
    {path: '/orderData/imgShow/:orderNo', name: '查看照片', component: imgShow, meta: {title: '查看照片'}},
    {path: '/order/imgShow/:traceId', name: '查看照片', component: imgShow, meta: {title: '查看照片'}},
    {path: '/dl/driver', name: '下载司机端', component: downloadDriver, meta: {title: '下载司机端'}},
    {path: '/dl/owner', name: '下载货主端', component: downloadOwner, meta: {title: '下载货主端'}},
    {path: '/face/:type', name: '快速认证', component: rlrz, meta: {title: '快速认证'}},
    {path: '/eqb/faceResult', name: '人脸认证结果', component: faceResult, meta: {title: '人脸认证结果'}},
    {path: '/eqb/meidaNotify', name: '美达人脸认证结果', component: meidaNotify, meta: {title: '美达人脸认证结果'}},
    {path: '/getFaceUrl', name: '获取人脸链接', component: getFaceUrl, meta: {title: '获取人脸链接'}},
    {path: '/dz/activity', name: '垫资申请', component: dzActivity, meta: {title: '垫资申请'}},
    {path: '/dz/wjx', name: '问卷星', component: dzWjx, meta: {title: '问卷星'}},
    {path: '/faceAuth', name: '上传身份证', component: faceAuth, meta: {title: '上传身份证'}},
    {path: '/faceAuth/:type', name: '上传身份证', component: faceAuth, meta: {title: '上传身份证'}},
    {path: '/y/login', name: '邀请人登录', component: yqlogin, meta: {title: '邀请人登录'}},
    {path: '/y/detail', name: '邀请人详情', component: yqdetail, meta: {title: '邀请人详情'}},
    {path: '/y/Qrcode', name: '邀请人二维码', component: yqQrcode, meta: {title: '邀请人二维码'}},

    {path: '/b/login/:id', name: '被邀请人登录', component: byqlogin, meta: {title: '被邀请人登录'}},
    {path: '/b/form/:id', name: '证件信息', component: byqform, meta: {title: '证件信息'}},
    {path: '/b/form1/:id', name: '证件信息', component: byqform1, meta: {title: '证件信息'}},
    {path: '/b/form2/:id', name: '证件信息', component: byqform2, meta: {title: '证件信息'}},
    {path: '/b/form3/:id', name: '证件信息', component: byqform3, meta: {title: '证件信息'}},
    {path: '/b/upSuccess/:type', name: '上传完成', component: upSuccess, meta: {title: '上传完成'}},
    /*获取订单收货码*/
    {path: '/orderCode/login', name: '获取收货码', component: orderCodeLogin, meta: {title: '登录'}},
    {path: '/orderCode/code', name: '获取收货码', component: orderCodeIndex, meta: {title: '查询收货码'}},

];

const router = new VueRouter({
    mode: 'history',  //正式用
    base: process.env.BASE_URL, routes
})
router.beforeEach((to, from, next) => {
    next()
});
export default router
